import React, { Component } from 'react';
import CartLineItem from './CartLineItem';

const CartList = ({ products, cart, API }) => {
  if (products == undefined || products.length < 1) {
    return (
      <div className="Loop Loop--minicart">
        <div className="empty-loop">You don't have any items in your bag.</div>
      </div>
    );
  } else {
    return (
      <>
        <div className="Loop Loop--minicart">
          {products.map((product) => (
            <CartLineItem product={product} key={product.id} API={API} />
          ))}
        </div>
        <div className="Minicart__footer">
          <ul className="MiniCart__totals">
            {cart.total_discount > 0 && (
              <li>
                <span className="label">Discounts</span>
                <span className="discount">${(cart.total_discount / 100).toFixed(2)}</span>
              </li>
            )}
            <li className="subtotal">
              <span className="label">Subtotal:</span>
              <span className="total">${(cart.total_price / 100).toFixed(2)}</span>
            </li>
          </ul>
          
          <form action="/cart" method="post" noValidate className="MiniCart__form">
            <button type="submit" name="cart" className="Button" data-style="outline dark">
              VIEW CART
            </button>
          </form>
          <form action="/checkout" method="post" noValidate className="MiniCart__form">
            <button type="submit" name="cart" className="Button" data-style="solid red">
              CHECKOUT
            </button>
          </form>
        </div>
      </>
    );
  }
};
export default CartList;
